<template>
  <div class="review-confirm" :class="{'print-page': isPrint}">
    <div style="width: 100%; overflow: hidden">
      <div class="information">

        <div class="borderDefault">
          <div class="title">Event Information</div>
          <div class="info-content">
            <div class="info-box" style="margin-bottom: 10px">
              <p>
                <span class="name">Receive and Return Date: </span>
                <span class="info">{{ eventInfo.startDate }} - {{ eventInfo.endDate }}</span>
                <br>
                <span class="name">Event Name: </span>
                <span class="info">{{ eventInfo.redBullEventName }}</span>
                <br>
                <span class="name">Internal Order: </span>
                <span class="info">{{ eventInfo.internalNumber || '---' }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="borderDefault" style="margin-top: 10px">
          <div class="title">Additional Information</div>
          <div class="info-content">
            <div class="info-box">
              <div class="info-title">OnSite TVU Operator</div>
              <p>
                <span class="name">First Name: </span>
                <span class="info">{{ additionalInfo.operatorFirstName }}</span>
              </p>
              <p>
                <span class="name">Last Name: </span>
                <span class="info">{{ additionalInfo.operatorLastName }}</span>
              </p>
              <p>
                <span class="name">Company Name: </span>
                <span class="info">{{ additionalInfo.operatorCompanyName || '---' }}</span>
              </p>
              <p>
                <span class="name">Email Address: </span>
                <span class="info">{{ additionalInfo.operatorEmailAddress }}</span>
              </p>
              <p>
                <span class="name">Send confirmation email to TVU Operator:  &nbsp;</span>
                <el-checkbox
                  disabled v-model="additionalInfo.sendRentalRequestConfirmationMailToOperator"
                ></el-checkbox>
              </p>
            </div>
            <div class="info-box" style="margin-top: 10px;margin-bottom: 10px;padding-bottom: 31px">
              <p>
                <span class="name">Green Toolkit Link: </span>
                <span class="info">{{ additionalInfo.operatorGreenToolkitLink }}</span>
              </p>
              <p>
                <span class="name" style="margin-right: 8px;">IFB: </span>
                <el-checkbox disabled v-model="additionalInfo.operatorIFB"></el-checkbox>
              </p>
              <p>
              <span class="info textOver" :title="additionalInfo.operatorNote || '---'">
                <span class="name" style="font-weight: normal">Note: &nbsp;</span>
                {{ additionalInfo.operatorNote || '---' }}
              </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="information borderDefault" style="margin-left: 12px">
        <div class="title">Business Contact and Shipping information</div>
        <div class="info-content">
          <div class="info-box">
            <div class="info-title">Business Contact</div>
            <p>
              <span class="name">First Name: </span>
              <span class="info">{{ confirmAddress.businessContactFirstName }}</span>
              <span class="name">Last Name: </span>
              <span class="info">{{ confirmAddress.businessContactLastName }}</span>
            </p>
            <p>
              <span class="name">Company Name: </span>
              <span class="info">{{ confirmAddress.businessContactCompany || '---' }}</span>
            </p>
            <p>
              <span class="name">Email Address: </span>
              <span class="info">{{ confirmAddress.businessContactEmail }}</span>
            </p>
            <p>
              <span class="name">Phone Number: </span>
              <span class="info">{{ confirmAddress.businessContactPhone }}</span>
            </p>
            <p>
              <span class="name">Other Communication Method: </span>
              <span
                class="info"
              >{{
                  confirmAddress.businessContactCommunicationType || '---'
                }} - {{ confirmAddress.businessOtherCommunicationMethods || '---' }}</span>
            </p>
            <p>
              <span class="name">Country/Region: </span>
              <span class="info">{{ confirmAddress.businessContactCountry }}</span>
              <span class="name">State/Province: </span>
              <span class="info">{{ confirmAddress.businessContactState || '---' }}</span>
            </p>
          </div>
          <div class="info-box" style="margin-top: 10px;margin-bottom: 10px">
            <div class="info-title">Shipping Information</div>
            <p>
              <span class="name">First Name: </span>
              <span class="info">{{ confirmAddress.shippingContactFirstName }}</span>
              <span class="name">Last Name: </span>
              <span class="info">{{ confirmAddress.shippingContactLastName }}</span>
            </p>
            <p>
              <span class="name">Company Name: </span>
              <span class="info">{{ confirmAddress.shippingContactCompany || '---' }}</span>
            </p>
            <p>
              <span class="name">Email Address: </span>
              <span class="info">{{ confirmAddress.shippingContactEmail }}</span>
            </p>
            <p>
              <span class="name">Phone Number: </span>
              <span class="info">{{ confirmAddress.shippingContactPhone }}</span>
            </p>
            <p>
              <span class="name">Other Communication Method: </span>
              <span
                class="info"
              >{{
                  confirmAddress.shippingContactCommunicationType || '---'
                }} - {{ confirmAddress.shippingOtherCommunicationMethods || '---' }}</span>
            </p>
            <p>
              <span class="name">Shipping Address: </span>
              <span
                class="info"
              >{{ confirmAddress.shippingAddress1 || '---' }} {{ confirmAddress.shippingAddress2 || '---' }}</span>
            </p>
            <p>
              <span class="name">Building Name: </span>
              <span class="info">{{ confirmAddress.buildingName || '---' }}</span>
            </p>
            <p>
              <span class="name">Country/Region: </span>
              <span class="info">{{ confirmAddress.shippingCountry }}</span>
              <span class="name">State/Province: </span>
              <span class="info">{{ confirmAddress.shippingState || '---' }}</span>
            </p>
            <p>
              <span class="name">City: </span>
              <span class="info">{{ confirmAddress.shippingCity }}</span>
              <span class="name">Postal Code: </span>
              <span class="info">{{ confirmAddress.shippingZipCode || '---' }}</span>
            </p>
            <p>
              <span class="name">Send confirmation email to shipping contact:  &nbsp;&nbsp;</span>
              <el-checkbox
                disabled v-model="confirmAddress.sendRentalRequestConfirmationMailToShippingContact"
              ></el-checkbox>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="cart-info">
      <span class="title">Shopping Cart</span>
      <div class="date-box">
        <span>Rental Period:</span>
        <el-date-picker
          @change="changeDate"
          size="medium"
          style="width: 100%;"
          v-model="formDate"
          :picker-options="pickerOptions"
          type="daterange"
          :editable="false"
          range-separator="-"
          start-placeholder="Receive and Return Date"
          end-placeholder=""
          :disabled="true"
        >
        </el-date-picker>
      </div>
    </div>
    <div class="product">
      <div class="title-box">
        <span>Equipment  Info</span>
        <span>Quantity</span>
        <span style="padding-left: 40px;">Operation</span>
      </div>
      <div v-for="item in chooseProducts" :key="item.id">
        <div class="product-item">
        <span class="product-name">
          <img :src="item.image" alt="">
          <span>{{ item.productName }}</span>
        </span>
          <el-input-number
            v-model="item.quantity"
            size="medium"
            :step="1"
            @change="handleChange"
            :min="1"
            :disabled="true"
            :precision="0"
          >
          </el-input-number>
          <span class="operation" @click="remove(item.productId)">Remove</span>
        </div>
      </div>
      <div class="product-item" v-if="specialRentalProductRequest">
      <span class="product-name">
        <img src="../../../assets/images/new-logo.png" alt="">
        <span>Additional Product Requirements</span>
      </span>
        <span class="request-text" v-if="!showEdit" @click="showEditChanges">{{ specialRentalProductRequest }}</span>
        <el-input
          ref="textareaInput"
          v-if="showEdit"
          type="textarea"
          :rows="4"
          v-model="specialRentalProductRequest"
          @blur="showEdit = !showEdit"
          @change="handleChange"
          placeholder="Enter your additional product requirements"
          :disabled="true"
        >
        </el-input>
        <span class="operation" @click="remove()">Remove</span>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from '../../../common/vueBus'
import { getDecodeUrlParam } from '@/assets/js/utils'

const moment = require('moment')

export default {
  name: 'ReviewConfirm',
  data () {
    return {
      formDate: [],
      pickerOptions: {
        disabledDate (time) {
          // 获取今天凌晨的时间戳
          // const today = new Date(new Date().toLocaleDateString()).getTime()
          const today = moment().startOf('day').valueOf()
          // console.log(today, time.getTime(), time.getTime() < today)
          return time.getTime() < today
        }
      },
      address: '',
      specialRentalProductRequest: '',
      chooseProducts: [],
      eventInfo: {},
      confirmAddress: {},
      additionalInfo: {},
      showEdit: false,
      isPrint: false
    }
  },
  mounted () {
    if (this.$route.path === '/print') {
      this.isPrint = true
      this.eventInfo = JSON.parse(getDecodeUrlParam('eventInfo') || '{}')
      this.chooseProducts = getDecodeUrlParam('chooseProducts') ? JSON.parse(getDecodeUrlParam('chooseProducts')) : []
      this.specialRentalProductRequest = getDecodeUrlParam('specialRentalProductRequest') || ''
      this.confirmAddress = JSON.parse(getDecodeUrlParam('confirmAddress') || '{}')
      this.additionalInfo = JSON.parse(getDecodeUrlParam('additionalInfo') || '{}')
    } else {
      this.isPrint = false
      this.eventInfo = JSON.parse(localStorage.getItem('eventInfo') || '{}')
      this.chooseProducts = localStorage.getItem('chooseProducts') ? JSON.parse(localStorage.getItem('chooseProducts')) : []
      this.specialRentalProductRequest = localStorage.getItem('specialRentalProductRequest') || ''
      this.confirmAddress = JSON.parse(localStorage.getItem('confirmAddress') || '{}')
      this.additionalInfo = JSON.parse(localStorage.getItem('additionalInfo') || '{}')
    }
    this.formDate = [this.eventInfo.startDate, this.eventInfo.endDate]
  },
  methods: {
    showEditChanges () {
      this.showEdit = !this.showEdit
      // 使input自动获取焦点
      this.$nextTick(() => {
        this.$refs.textareaInput.focus()
      })
    },
    handleChange () {
      localStorage.setItem('chooseProducts', JSON.stringify(this.chooseProducts))
      localStorage.setItem('specialRentalProductRequest', this.specialRentalProductRequest)
    },
    remove (value) {
      if (value || value === 0) {
        this.chooseProducts.splice(this.chooseProducts.findIndex(item => item.id === value), 1)
        localStorage.setItem('chooseProducts', JSON.stringify(this.chooseProducts))
      } else {
        this.specialRentalProductRequest = ''
        localStorage.setItem('specialRentalProductRequest', '')
      }
      Bus.$emit('cartNumChange')
    },
    changeDate () {
      const start = moment(this.formDate[0]).format('YYYY-MM-DD')
      const end = moment(this.formDate[1]).format('YYYY-MM-DD')
      this.eventInfo.startDate = start
      this.eventInfo.endDate = end
      // 第一步的数据存储
      localStorage.setItem('eventInfo', JSON.stringify(this.eventInfo))
    }
    // onSubmit() {
    //   if (this.chooseProducts.every(item => item.quantity === 0) && !this.specialRentalProductRequest) {
    //     this.$message.error('Please select at least one product')
    //   } else {
    //     this.$confirm('', 'Confirm Rental Request', {
    //       confirmButtonText: 'Confirm',
    //       cancelButtonText: 'Cancel',
    //       customClass: 'review-confirm-box',
    //       type: 'warning'
    //     }).then(() => {
    //       this.$emit('submitChange')
    //     }).catch(() => {
    //     })
    //   }
    // }
  }
}
</script>

<style scoped lang="less">
.borderDefault {
  border: 1px solid #DBDBDB;
}

.information {
  border-radius: 4px;
  //border: 1px solid #DBDBDB;
  background: #FAFAFA;
  margin-bottom: 10px;
  width: calc(50% - 6px);
  float: left;
  box-sizing: border-box;
  overflow: hidden;

  .title {
    border-radius: 4px 4px 0 0;
    //background: #F0F0F0;
    padding: 8px 24px;
    //color: #666666;
    font-size: 14px;
    font-weight: 700;
    color: #69AD48;
  }

  .info-content {
    //display: flex;
    //justify-content: flex-start;
  }

  .info-box {
    //display: inline-block;
    padding: 16px 20px;
    border-radius: 4px;
    width: calc(100% - 20px);
    padding: 16px 20px;
    margin-left: 10px;
    background: #fff;
    //border: 1px solid #69AD48;
    //margin: 24px 0 24px 24px;

    .info-title {
      color: #333333;
      font-weight: 700;
      font-size: 14px;
      margin-bottom: 8px;
    }

    p {
      font-size: 14px;
      line-height: 24px;

      .name {
        color: #999999;
        display: inline-block;
      }

      .info {
        color: #333333;
        font-weight: 400;
        margin-right: 20px;
        margin-left: 4px;
      }
    }
  }
}

.cart-info {
  display: flex;
  justify-content: space-between;
  margin-top: 36px;
  margin-bottom: 12px;

  .title {
    color: #69AD48;
    font-size: 16px;
    font-weight: 700;
  }

  .date-box {
    display: flex;
    align-items: center;

    span {
      color: #444;
      font-size: 14px;
      font-weight: 700;
      margin-right: 12px;
    }
  }
}

.product {
  border-radius: 4px;
  border: 1px solid #DBDBDB;
  background: #FAFAFA;
  margin-bottom: 40px;
}

.title-box {
  display: flex;
  padding: 8px 24px;
  background: #F0F0F0;
  color: #69AD48;

  span {
    width: 33.33%;
    color: #666666;
    font-weight: 700;
    font-size: 14px;
  }
}

.product-item {
  display: flex;
  padding: 8px 24px;
  align-items: center;
  border-bottom: dashed 1px #DBDBDB;
  font-size: 14px;

  .product-name {
    width: 33.33%;
    display: flex;
    align-items: center;

    span {
      color: #333333;
    }

    img {
      width: 26px;
      margin-right: 10px;
    }
  }

  .operation {
    width: 33.33%;
    color: #666666;
    cursor: pointer;
    padding-left: 40px;
  }

  /deep/ .el-input-number--medium {
    width: 160px;
    margin-right: 200px;
  }

  .request-text {
    color: #333;
    display: inline-block;
    width: 33.33%;
    cursor: pointer;
  }
}

.product-item:last-child {
  //border-bottom: none;
}

/deep/ .el-date-editor {
  width: 242px !important;
}

/deep/ .el-textarea {
  width: 33.33%;
}

.print-page {
  .product-item {
    /deep/ .el-input-number--medium {
      width: 33.3% !important;
      margin-right: 0 !important;
    }
  }
}

.textOver {
  margin-left: 0 !important;
  height: 67px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>
